import React from "react";
import ChangePasswordFormDialog from "../../../../components/common/ChangePasswordFormDialog";

const ChangePasswordDialog = ({
  open,
  user,
  loading = false,
  onClose,
  onSubmit,
}) => {
  return (
    <ChangePasswordFormDialog
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      loading={loading}
      description={`Update password for ${
        user?.username || user?.userId || "selected user"
      }`}
    />
  );
};

export default ChangePasswordDialog;
